import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(customParseFormat);
dayjs.extend(utc);
dayjs.extend(timezone);

export function formatDateAndTime(dateString: string | null | undefined): string {
  if (!dateString) return '-';
  const options: Intl.DateTimeFormatOptions = {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  };
  return new Date(dateString).toLocaleString('en-US', options);
}

export function formatDate(dateString: string | null | undefined): string {
  if (!dateString) return '-';
  const date = new Date(dateString);

  const options: Intl.DateTimeFormatOptions = {
    month: 'short',
    day: 'numeric',
    year: 'numeric'
  };

  return date.toLocaleDateString('en-US', options);
}

// export const formatTime = (time: string): string => {
//   const parsed = dayjs(time, 'HH:mm', true);
//   return parsed.isValid() ? parsed.format('hh:mm A') : time;
// };

export const formatTime = (input: string): string => {
  const isTimeOnly = dayjs(input, 'HH:mm', true).isValid();

  if (isTimeOnly) {
    return dayjs(input, 'HH:mm').format('hh:mm A');
  }

  const parsedDate = dayjs.utc(input);
  if (parsedDate.isValid()) {
    const localTime = parsedDate.local();
    return localTime.format('hh:mm A');
  }

  return input;
};
